export function isModelCheckConsents(model: CF.API.Models.Model): boolean {
  return model.check_consents ? model.check_consents.includes('pii') : false;
}

export function isWorkflowCheckConsents(workflow: CF.API.Workflows.Workflow): boolean {
  return workflow.check_consents ? workflow.check_consents.includes('pii') : false;
}
